import React from 'react'
import { StaticQuery, Link } from 'gatsby'
import _ from 'lodash'
import Img from 'gatsby-image'
import styled from 'styled-components'

const BlogContent = styled.div`
 margin:3em 0;
  position: sticky;
    top: 100px;
  a {
    text-transform: uppercase;
    display: block;
  }
`

const ClientPostNav = () => (
  <StaticQuery
    query={graphql`
      query WorktNavigationQuery {
        allPrismicPersonal(filter: {data: {indexed: {nin: true}}}, sort: {order: ASC, fields: data___title___text}) {
          edges {
            node {
              data {
                title {
                  text
                }
              
              }
              uid
              slugs
            }
          }
        }
      }
    `}
    render={data => (
      <BlogContent>
       

        {data.allPrismicPersonal.edges.map(({ node }) => (
               <div>
                 <Link className="test" to={`/${node.uid}`}>{node.data.title.text} </Link>
             </div>
        ))}
      </BlogContent>
    )}
  />
)

export default ClientPostNav